module.exports = __webpack_public_path__ + "static/img/baImg.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/baImg.png
// module id = GbLY
// module chunks = 51